import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";
import PositionForm from "../default/position/PositionForm";
import SizeForm from "../default/size/SizeForm";

function QrFormView({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  return (
    <StyledFlexColumn>
      {/* X & Y */}
      <PositionForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Width & Height */}
      <SizeForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />
    </StyledFlexColumn>
  );
}

export default QrFormView;
